export default "__VITE_ASSET__x_U7Cr7t__"